export default [
  'https://www.nerdwallet.com/cdn/company/2023/values/v2/Company-Carousel-01-sfw.jpg',
  'https://www.nerdwallet.com/cdn/company/2023/values/v2/Company-Carousel-02-sfw.jpg',
  'https://www.nerdwallet.com/cdn/company/2023/values/v2/Company-Carousel-03-sfw.jpg',
  'https://www.nerdwallet.com/cdn/company/2023/values/v2/Company-Carousel-04-sfw.jpg',
  'https://www.nerdwallet.com/cdn/company/2023/values/v2/Company-Carousel-05-sfw.jpg',
];
